import { useRef, useState } from "react";
import { ReactComponent as AudioButtonIcon } from "../../../assets/designSystem/icons/audio_player.svg";
import { ReactComponent as AudioButtonUnableIcon } from "../../../assets/designSystem/icons/audio_player_unabled.svg";
import KitoButton from "../KitoButton";
import { useTranslation } from "react-i18next";
import { tts } from "../../../API/api";
import { ELEVENLABS_VOICE_ID } from "../../../utils";

const voiceId = ELEVENLABS_VOICE_ID;

const getAudioUrlFromCache = async (cacheName, message) => {
    const cacheKey = `https://kito-tts-cache.local/${encodeURIComponent(voiceId)}/${encodeURIComponent(message)}`;
    const cache = await caches.open(cacheName);

    let response = await cache.match(cacheKey);

    if (!response) {
        response = await tts(message, voiceId);

        if (!response || !response.ok || !response.body) {
            return null;
        }

        await cache.put(cacheKey, response.clone());
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
};


function KitoAudioButton({ message, name }) {
    const [playStatus, setPlayStatus] = useState('ready');
    const { i18n } = useTranslation();

    const playStreamAudio = async () => {
        try {
            setPlayStatus('loading');

            const cacheName = `${name}_${i18n.language}`;
            const audioUrl = await getAudioUrlFromCache(cacheName, message);

            if (!audioUrl) {
                setPlayStatus('error');
                throw new Error('Error requesting audio:');
            }

            const audio = new Audio(audioUrl)

            setPlayStatus("playing");

            audio.onended = () => {
                setPlayStatus('ready');
            };

            audio.onerror = (e) => {
                console.error('Erro playing audio:', e);
                setPlayStatus('error');
            };

            await audio.play();
        } catch (err) {
            console.error('Erro playing audio:', err);
            setPlayStatus('error');
        }
    }

    return <KitoButton type="button" hierarchy="icon" disabled={playStatus !== 'ready'} onClick={playStreamAudio}>
        {playStatus === 'error' ? <AudioButtonUnableIcon /> : <AudioButtonIcon />}
    </KitoButton>
}

export default KitoAudioButton;

